import React, { useState } from "react";
import baseApi from "../../../apis/baseApi";
import { getApiErrorMessage } from "../../../utils/api_utils";
import PlanCard from "../Plans/PlanCard";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";



const WompiFreePlanCheckout = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const plan = location.state.plan

  const [submitting, setSubmitting] = useState(false);
  const [errorMsg, setErrorMsg] = useState<string>();

  const renderFreePlanButton = () => {
    if (parseFloat(plan.price) > 0) return <React.Fragment/>
    return <div className="text-center">
      <button
        disabled={submitting}
        className="btn btn-primary btn-lg  font-weight-bolder mt-5 px-20"
        onClick={() => {
          setSubmitting(true)
          setErrorMsg(undefined)
          baseApi.post("/sales/freebuy/", {
            plan: plan.id
          }).then(resp => {
            console.log(resp.data)
            navigate("/purchase-details")
          }).catch(err => {
            setErrorMsg(getApiErrorMessage(err))
            setSubmitting(false)
          })
        }}
      >
        Comprar
      </button>
    </div>
  }

  return (
    <div>
      <div className="d-flex text-center align-items-center mb-2 pt-3">
        <button className="btn mr-auto" onClick={() => {
          navigate(-1)
        }}><FontAwesomeIcon icon={faChevronLeft}/>
        </button>
        <div className="text-center font-size-h3 ml-n10  mr-auto">Confirma tu compra</div>
      </div>
      {/* PLAN CARD */}
      <div className="row justify-content-center">
        <div className="col-10 col-xl-10 col-xxl-8 ">
          <PlanCard plan={plan} checkoutMode={true} />
          <div className="text-center">
            {renderFreePlanButton()}
          </div>
        </div>
      </div>
      <div>
        <div className="text-center text-danger mt-2">
          {errorMsg}
        </div>
      </div>
    </div>
  );
};

export default WompiFreePlanCheckout;
